interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "money (3)" asset from the Dimensions header Figma frame (76071:5647). */
const FigmaMoneyIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        transform='translate(0, 7.4288)'
        d='M0.218101 0.591323C0.0461069 0.654665 -0.0425463 0.845314 0.0201078 1.01796L0.229444 1.59394L1.82336 0L0.218101 0.591323Z'
        fill={color}
      />
      <path
        transform='translate(1.7264, 13.1408)'
        d='M0 0L0.959966 2.63991C0.989965 2.72325 1.05262 2.79125 1.13262 2.8279C1.17727 2.84856 1.22527 2.85924 1.27327 2.85924C1.31261 2.85924 1.35126 2.85259 1.38861 2.83859L2.44791 2.44795L0 0Z'
        fill={color}
      />
      <path
        transform='translate(8.8992, 7.8656)'
        d='M7.08041 3.02055L5.98179 0L3.34523 2.63656L4.65184 2.15524C4.82317 2.0899 5.01648 2.17924 5.07982 2.35257C5.14382 2.52522 5.05517 2.71722 4.88249 2.78056L3.22254 3.39254C3.18454 3.40654 3.14589 3.41319 3.1072 3.41319C2.97186 3.41319 2.84387 3.32985 2.79456 3.1952C2.7939 3.1932 2.79456 3.1912 2.7939 3.1892L0 5.9831L6.88242 3.44719C7.05507 3.38388 7.14372 3.1932 7.08041 3.02055Z'
        fill={color}
      />
      <path
        d='M15.9016 5.43065L10.5685 0.0974966C10.4385 -0.0324989 10.2271 -0.0324989 10.0971 0.0974966L0.0974966 10.0971C-0.0324989 10.2271 -0.0324989 10.4385 0.0974966 10.5685L5.43065 15.9016C5.49531 15.967 5.58065 15.9996 5.66599 15.9996C5.75133 15.9996 5.83664 15.967 5.90198 15.9023L15.9016 5.90264C16.0316 5.77198 16.0316 5.5613 15.9016 5.43065ZM3.90205 9.23586L2.56875 10.5691C2.50341 10.6338 2.4181 10.6665 2.33276 10.6665C2.24742 10.6665 2.16211 10.6338 2.09677 10.5691C1.96677 10.4391 1.96677 10.2278 2.09677 10.0978L3.43007 8.7645C3.56006 8.63451 3.7714 8.63451 3.90139 8.7645C4.03139 8.89453 4.03205 9.10518 3.90205 9.23586ZM9.6585 9.65916C9.42251 9.89515 9.10187 10.0085 8.74519 10.0085C8.15587 10.0085 7.46724 9.69985 6.89126 9.12318C6.46993 8.70185 6.17394 8.19787 6.05863 7.70457C5.93064 7.15459 6.03598 6.67595 6.35528 6.35596C6.67461 6.03598 7.15325 5.93064 7.70389 6.05932C8.19721 6.17466 8.70119 6.46996 9.12249 6.89195C10.0485 7.81723 10.2845 9.03318 9.6585 9.65916ZM13.9017 5.90264L12.5684 7.23593C12.5031 7.30059 12.4178 7.33327 12.3324 7.33327C12.2471 7.33327 12.1618 7.30062 12.0964 7.23593C11.9664 7.10594 11.9664 6.8946 12.0964 6.76461L13.4297 5.43131C13.5597 5.30131 13.771 5.30131 13.901 5.43131C14.031 5.5613 14.0317 5.77198 13.9017 5.90264Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaMoneyIcon;
